export function getParam(param) {
    let key = param;
    let search = window.location.search.substring(1);
    if (Object.prototype.toString.call(param) === '[object Object]') {
        param.url && (search = param.url.split('?')[1] || '');
        key = param.key ? param.key : null;
    }
    let obj = {};
    search.split('&').map((item) => {
        let one = item.split('=');

        obj[one[0]] = one[1];
        return item;
    });

    if (key) {
        return obj[key];
    }
    else {
        return obj;
    }

}

export function getHashString(name, url = location.hash) {
    console.log(url, name);
    var arr = (url || '')
        .substr(url.indexOf('?') + 1)
        .replace(/^\#/, '')
        .split('&');
    console.log(arr);
    var params = {};
    for (var i = 0; i < arr.length; i++) {
        var data = arr[i].split('=');
        if (data.length == 2 && data[0] == name) {
            console.log(data[1]);
            return data[1];
        }
    }

    return null;
}

export function parseURL(url = window.location.href) {
    var a = document.createElement('a');
    a.href = url;
    return {
        source: url,
        protocol: a.protocol.replace(':', ''),
        host: a.hostname,
        port: a.port,
        query: a.search,
        params: (function () {
            var ret = {};
            var seg = a.search.replace(/^\?/, '').split('&'); //将该字符串首位的?替换成空然后根据&来分隔返回一个数组
            var len = seg.length;
            var i = 0;
            var s;
            for (; i < len; i++) {
                if (!seg[i]) {
                    continue;
                }
                s = seg[i].split('=');
                ret[s[0]] = s[1];
            }
            return ret;
        })(),
        file: (a.pathname.match(/\/([^\/?#]+)$/i) || ['', ''])[1],
        hash: a.hash.replace('#', ''),
        path: a.pathname.replace(/^([^\/])/, '/$1'), //将该字符串首位不是/的用这个组([^\/])替换，$1代表出现在正则表达式中的第一个()、$2代表出现在正则表达式中的第二个()...
        relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || ['', ''])[1],
        segments: a.pathname.replace(/^\//, '').split('/')
    };
}

export function parseObjToUrl(param, key) {
    var paramStr = '';
    var mappingOperator = '=';
    var separator = '&';
    if (param instanceof String || typeof (param) == 'string' || param instanceof Number || typeof (param) == 'number' || param instanceof Boolean || typeof (param) == 'boolean') {
        paramStr += separator + key + mappingOperator + encodeURIComponent(param);
    } else {
        for (var i in param) {
            var value = param[i];
            var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
            paramStr += separator + parseObjToUrl(value, k);
        }
    }
    return paramStr.substr(1);
}

export function handleJumpUrl(key, param) {
    let path = location.protocol + '//' + location.hostname + '/crmForm/form/';
    let pre = /^http/.test(key) ? key : path + key;
    let dealQuery = parseObjToUrl(getParam());
    let url = `${pre}?${dealQuery}`;
    if (param) {
        url = `${pre}?${param}${dealQuery}`;
    }
    if (window.__wxjs_environment === 'miniprogram') {
        window.wx && window.wx.miniProgram.navigateTo({
            url: `/pages/phoneGrant/index?formUrl=${encodeURIComponent(url)}`
        });
        return;
    }
    window.location.href = url;
}

export function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) return unescape(arr[2]);
    else return null;
}

export function setCookie(name, value) {
    var Days = 1;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}

export function getUUID () {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid
}